import { Box, Divider, Paper, Skeleton, Stack } from "@mui/material";

function FamilyListCardSkeleton() {
  return (
    <Paper
      variant="outlined"
      sx={{ borderRadius: "4px", borderColor: "#0000001F", overflow: "hidden", flex: 1 }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
        <Skeleton width={140} height={24} />
        <Skeleton width={20} height={24} />
      </Box>
      <Divider />
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2, py: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton width="50%" />
              <Skeleton width="70%" />
            </Box>
            <Stack direction="row" spacing={0.5}>
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </Stack>
          </Box>
          {index < 3 && <Divider />}
        </Box>
      ))}
    </Paper>
  );
}

/** Placeholder that mirrors the Needs Attention tabs + lists while Q4 is loading. */
const NeedAttentionTabsSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          width: "100%",
          alignItems: "flex-start",
          justifyContent: "space-between",
          padding: "0px 16px 20px",
        }}
      >
        <Skeleton variant="rounded" width={260} height={38} />
        <Skeleton variant="rounded" width={300} height={38} />
      </Box>

      <Stack direction="row" spacing={2} pb={2} px={2}>
        <FamilyListCardSkeleton />
        <FamilyListCardSkeleton />
      </Stack>
    </Box>
  );
};

export default NeedAttentionTabsSkeleton;
